// Site URLs
export const SITE_URLS = {
  BASE: 'https://overblock.io',
  DASHBOARD: 'https://dashboard.overblock.io',
  POLICY: '/policy',
  TERMS: '/terms',
  FEATURES: '#features',
  HOW_DOES_IT_WORK: '#how-does-it-work',
  ROADMAP: '#roadmap',
  JOIN: '#join',
  EXAMPLE: '#example',
} as const;
